<nav class="navbar navbar-expand-lg bg-body-tertiary" aria-label="main navigation" data-bs-theme="dark">
    <div class="container-fluid">
        <div class="navbar-brand" i18n>
            Data Donation
        </div>

        <button class="navbar-toggler" type="button" aria-controls="navigation-links"
            [attr.aria-expanded]="burgerActive" aria-label="toggle navigation" (click)="toggleBurger()">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div id="navigation-links" class="navbar-collapse" [ngbCollapse]="!burgerActive">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a [routerLink]="['/home']" routerLinkActive="active" class="nav-link" i18n>
                        Home
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/privacy']" routerLinkActive="active" class="nav-link" i18n>
                        Privacy
                    </a>
                </li>
            </ul>

            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <ell-dark-mode-toggle role="listitem" class="nav-item" />
                </li>
                @if (languages) {
                <li class="nav-item" ngbDropdown>
                    <button class="nav-link" ngbDropdownToggle id="language-dropdown-toggle" aria-label="language">
                        @if (loading) {
                        <span class="spinner-border spinner-border-sm"></span>
                        <span class="visually-hidden">Loading languages...</span>
                        } @else {
                        <fa-icon [icon]="faGlobe" aria-hidden="true" />
                        }
                    </button>
                    <div ngbDropdownMenu aria-labelledby="language-dropdown-toggle"
                        class="dropdown-menu dropdown-menu-end">
                        @if (languageService.disableLanguageToggle$ | async) {
                        <span ngbDropdownItem i18n i18n-title
                            title="Once the submission is started, toggling the language would mean restarting the submission and losing those files.">Toggling
                            language is disabled</span>
                        }
                        @else {
                        <button *ngFor="let language of languages" ngbDropdownItem
                            [class.active]="language.code == currentLanguage"
                            [attr.aria-pressed]="language.code == currentLanguage" (click)="setLanguage(language.code)">
                            {{language.name}}
                        </button>
                        }
                    </div>
                </li>
                }
            </ul>
        </div>
    </div>
</nav>
